import { ClientItemId } from 'owa-client-ids';
import GetAttachmentTextPreviewReadMode from 'owa-service/lib/contract/GetAttachmentTextPreviewReadMode';
import { action } from 'satcheljs';
import PendingOperationState from '../store/schema/PendingOperationState';
import { ComposeOperation } from 'owa-mail-compose-store';

export const closeComposeInSxS = action('closeComposeInSxS', (composeViewState: any) => ({
    composeViewState,
}));

export const editAndReply = action(
    'editAndReply',
    (
        loadDraftToCompose: (
            itemId: ClientItemId,
            sxsId: string,
            forceInsertSignatureOperation?: ComposeOperation
        ) => Promise<void>,
        createReply: (referenceItemId: ClientItemId) => Promise<ClientItemId>,
        trySaveAndCloseCompose: (
            conversationId: string,
            composeId: string
        ) => Promise<ClientItemId>,
        sxsId: string
    ) => ({
        loadDraftToCompose,
        createReply,
        trySaveAndCloseCompose,
        sxsId,
    })
);

export const editInDraft = action(
    'editInDraft',
    (
        loadDraftToCompose: (
            itemId: ClientItemId,
            sxsId: string,
            forceInsertSignatureOperation?: ComposeOperation
        ) => Promise<void>,
        sxsId: string
    ) => ({
        loadDraftToCompose,
        sxsId,
    })
);

export const forceCloseSxS = action(
    'forceCloseSxS',
    (closingSource: string, sxsId: string, shouldCloseWindow?: boolean) => ({
        closingSource,
        sxsId,
        shouldCloseWindow,
    })
);

export const openComposeInSxS = action('openComposeInSxS', (composeId: string, sxsId: string) => ({
    composeId,
    sxsId,
}));

export const tryCloseSxS = action('tryCloseSxS', (closingSource: string, sxsId: string) => ({
    closingSource,
    sxsId,
}));

export const tryExitSxSEditMode = action('tryExitSxSEditMode', (sxsId: string) => ({
    sxsId,
}));

export const onPreviewOperationStart = action(
    'onPreviewOperationStart',
    (pendingPreviewOperation: PendingOperationState, sxsId: string) => ({
        pendingPreviewOperation,
        sxsId,
    })
);

export const onPreviewOperationFinished = action('onPreviewOperationFinished', (sxsId: string) => ({
    sxsId,
}));

export const onPendingNavigation = action(
    'onPendingNavigation',
    (attachmentId: string, sxsId: string) => ({
        attachmentId,
        sxsId,
    })
);

export const onChangeByImageGallery = action('onChangeByImageGallery', (sxsId: string) => ({
    sxsId,
}));

export const onShowCustomPreview = action(
    'onShowCustomPreview',
    (customPreviewState: any, sxsId: string) => ({
        customPreviewState,
        sxsId,
    })
);

export const saveToCloud = action('saveToCloud', (entryPoint: string, sxsId: string) => ({
    entryPoint,
    sxsId,
}));

export const openSxSInANewWindow = action(
    'openSxSInANewWindow',
    (parentItemId: ClientItemId, attachmentId: string, isEdit: boolean, startTime?: number) => ({
        parentItemId,
        attachmentId,
        isEdit,
        startTime,
    })
);

export const reloadTextPreview = action(
    'reloadTextPreview',
    (readMode: GetAttachmentTextPreviewReadMode, sxsId: string) => ({
        readMode,
        sxsId,
    })
);
